module.exports = "<h3>Thank you for the submission</h3>\n<p><a [href]=\"submitAgainLink\">Submit again</a></p>\n"